function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Document, Page } from 'react-pdf';
import { FormattedMessage } from 'react-intl';
import ArrowIcon from 'svg/ap/arrow.svg';
import useWindowWidth from 'hooks/useWindowWidth';
import { isDevice } from 'helpers/isDevice';
import messages from 'modules/Mobile/messages';
import { onExternalPrint } from './helpers';
import styles from './PDFViewer.pcss';
import Actions from './Actions';
/* ATTENTION!! src/client.js contains pdf global worker configuration for this component. */ const loadingText = /*#__PURE__*/ _jsx("h3", {
    className: `text--h3 p-8 text-align--center ${styles.loading__headingText}`,
    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.loading))
});
const PDFViewer = ({ fileUrl, CustomActions, onLoadError })=>{
    useStyles(styles);
    const windowWidth = useWindowWidth();
    const [pagesNumber, setPagesNumber] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const contentRef = useRef(null);
    const reactToPrint = useReactToPrint({
        contentRef
    });
    const onDocumentLoadSuccess = ({ numPages })=>{
        setPageNumber(1);
        setPagesNumber(numPages);
    };
    const onDocumentLoadError = ()=>null;
    const viewerProps = {
        file: fileUrl,
        onLoadSuccess: onDocumentLoadSuccess,
        onLoadError: onLoadError || onDocumentLoadError,
        error: '',
        loading: loadingText
    };
    const changePage = (offset)=>{
        setPageNumber((prevPageNumber)=>prevPageNumber + offset);
    };
    const previousPage = ()=>{
        if (pageNumber >= 2) {
            changePage(-1);
        }
    };
    const nextPage = ()=>{
        if (pageNumber < pagesNumber) {
            changePage(1);
        }
    };
    const onPrintHandler = ()=>{
        if (isDevice('Android')) {
            reactToPrint();
        } else {
            onExternalPrint(fileUrl);
        }
    };
    const renderAllPages = ()=>[
            ...Array(pagesNumber)
        ].map((_, page)=>page <= pagesNumber ? /*#__PURE__*/ _jsx(Page, {
                pageNumber: page + 1,
                width: windowWidth - 32
            }) : null);
    if (!fileUrl) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.viewer,
        children: [
            /*#__PURE__*/ _jsx(Document, _object_spread_props(_object_spread({}, viewerProps), {
                children: /*#__PURE__*/ _jsx(Page, {
                    pageNumber: pageNumber,
                    width: windowWidth - 32
                })
            })),
            /*#__PURE__*/ _jsxs("nav", {
                className: styles.viewer__nav,
                children: [
                    /*#__PURE__*/ _jsx(ArrowIcon, {
                        className: `${styles.viewer__navIcon}`,
                        onClick: previousPage
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: styles.viewer__navPagination,
                        children: [
                            pageNumber || (pagesNumber ? 1 : '--'),
                            " / ",
                            pagesNumber || '--'
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ArrowIcon, {
                        className: `${styles.viewer__navIcon} ${styles['viewer__navIcon--right']}`,
                        onClick: nextPage
                    })
                ]
            }),
            isDevice('Android') && /*#__PURE__*/ _jsx("div", {
                ref: contentRef,
                className: styles.viewer__hiddenPages,
                children: /*#__PURE__*/ _jsx(Document, _object_spread_props(_object_spread({}, viewerProps), {
                    children: renderAllPages()
                }))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.viewer__bottomNav,
                children: CustomActions ? /*#__PURE__*/ _jsx(CustomActions, {
                    fileUrl: fileUrl
                }) : /*#__PURE__*/ _jsx(Actions, {
                    fileUrl: fileUrl,
                    onPrint: onPrintHandler
                })
            })
        ]
    });
};
export default PDFViewer;
